<template>
  <div
    v-if="(param === 'layout.grid.gap' && optionEnabled) || param !== 'layout.grid.gap'"
    class="control"
  >
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div class="control__trigger" @mouseover="showHint = true" @mouseleave="showHint = false">
            <img src="https://sirv.sirv.com/website/theme2/icon/question.svg" :alt="hint" />
          </div>
          <div v-show="showHint" class="hint">
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice slider">
        <div
          class="fakeoverlay"
          :class="{ disabled: !sliderStatus }"
          @click="sliderStatus = !sliderStatus"
        />
        <el-slider
          v-model="value"
          :min="min"
          :step="stepExp"
          :max="max"
          :class="{ disabled: !sliderStatus }"
          :disabled="!sliderStatus"
          @change="changeOption"
          @input="moveMotionMethod"
        />
      </div>
      <el-checkbox v-model="sliderStatus" class="control__checkbox" @change="changeOption" />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import optionEnabled from "@/store/observable/option-enabled";

export default {
  name: "SliderInput",
  props: {
    title: {
      type: String,
      default: "",
    },
    default: {
      type: [Number, String],
      default: 0,
    },
    hint: {
      type: String,
      default: "",
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
      default: 1,
    },
    status: {
      type: Boolean,
    },
    parameter: {
      type: String,
      default: "",
    },
    eventClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: parseInt(this.default),
      sliderStatus: this.status,
      showHint: false,
      stepExp: 1,
      param: this.parameter,
    };
  },
  computed: {
    optionEnabled,
    ...mapState(["clearOptions"]),
  },
  watch: {
    clearOptions(val) {
      if (val) {
        this.sliderStatus = false;
      }
    },
    eventClick(val) {
      this.sliderStatus = val;
      this.value = parseInt(this.default);
    },
    sliderStatus(val) {
      if (val === true) {
        this.changeOption();
      }
    },
  },
  methods: {
    changeOption() {
      const value = this.sliderStatus === true ? `${this.value}` : "";

      this.$emit("changeOption", {
        parameter: `${this.parameter}`,
        separator: ":",
        value: value,
      });
    },
    between(x, min, max) {
      return x >= min && x <= max;
    },
    moveMotionMethod(val) {
      if (this.parameter === "model.exposure") {
        if (this.between(val, 0, 1)) {
          this.stepExp = 0.1;
        } else if (this.between(val, 2, 100)) {
          this.stepExp = 1;
        }
      }
    },
  },
};
</script>
